import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "components";

type PublicRouteLayoutProps = {
  children: React.ReactNode;
};

export const PublicRouteLayout = ({ children }: PublicRouteLayoutProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="main-container">{children}</div>
    </ErrorBoundary>
  );
};
